<script>
import ReportResults from '@/components/ReportResults'
import Container from '@/components/Container'

export default {
  name: 'ReportResultsModal',
  props: {
    reportName: { required: true, type: String },
    reportDescription: { type: String },
    reportRecords: { required: true, type: Array },
    reportFields: { type: Array },
    reportParameters: { type: Object },
    reportDetails: { type: Object },
    chartTypes: {
      type: Array,
      default: () => {
        return ['table']
      }
    },
    chartType: { type: String },
    allowDownload: { type: Boolean, default: true },
    allowSave: { type: Boolean, default: true },
    allowFavorite: { type: Boolean, default: true },
    title: { type: String }
  },
  components: {
    ReportResults,
    Container
  }
}
</script>

<template>
  <b-modal
    id="report-results-modal"
    :title="title || reportName"
    size="xl"
    :hide-footer="true"
  >
    <Container :expanded="false">
      <template v-slot:header> Report Details: {{ reportName }} </template>
      <template v-slot:content>
        <p
          class="m-2 text-center report-details-description"
          v-html="reportDescription"
        ></p>
        <div v-if="reportDetails.formSchema">
          <hr />
          <PrintForm
            :fields="reportDetails.formSchema"
            :data="reportParameters"
          />
        </div>
      </template>
    </Container>
    <ReportResults
      :reportName="reportName"
      :reportRecords="reportRecords"
      :reportFields="reportFields"
      :reportParameters="reportParameters"
      :chartTypes="chartTypes"
      :chartType="chartType"
      :allowDownload="allowDownload"
      :allowSave="allowSave"
      :allowFavorite="allowFavorite"
      :reportDetails="reportDetails"
    />
  </b-modal>
</template>

<style>
#report-results-modal,
#report-results-modal .modal-dialog {
  max-width: unset;
}
.report-details-description .report-details-only {
  display: inline-block;
}
</style>
